<div (mouseenter)="showGetStartedPanel()" (mouseleave)="hideGetStartedPanelWithDelay()" class="d-flex justify-content-center" [ngClass]="[!isDrawerExpanded() ? 'mx-0 mb-2 mt-4' : 'mx-2 my-4']">
  @if(!isDrawerExpanded()){
  <div class="get-started-trigger collapse-get-started-icon" [ngClass]="{'image-padding': isInsideGettingStartedPanel()}">
    @if(isInsideGettingStartedPanel()) {
      <i class="fa-regular fa-circle-play fs-20 text-white"></i>
    } @else {
    <lottie-player #myLottie src="/assets/animations/get-started-play.json" autoplay loop speed="1"
                    background="transparent" style="width: 30px; height: 30px;"></lottie-player> 
    }
  </div>
} @else {
  <div class="get-started-trigger">
    <div class="progress-indicator d-flex align-items-center gap-8 justify-content-between">
      <span class="d-flex align-items-center gap-8">
        
          @if(isInsideGettingStartedPanel()) {
              <i class="fa-regular fa-circle-play fs-20 text-white"></i>
          } @else {
           <lottie-player #myLottie src="/assets/animations/get-started-play.json" autoplay loop speed="1"
                    background="transparent" style="width: 30px; height: 30px;"></lottie-player> 
          }
       
        <h5>Get Started</h5>
      </span>
      <p>{{currentStep()}}/{{totalSteps()}}</p>
    </div>
    <mat-progress-bar class="sidemenu-progress" mode="determinate"
      [value]="((currentStep() / totalSteps()) * 100)"></mat-progress-bar>
  </div>
}

</div>

@if(showPanel()){
<div class="get-started-panel" (mouseenter)="cancelHide()"  (mouseleave)="hideGetStartedPanel()" appSpin
[spinnerConfig]="spinnerConfig()" [ngClass]="{'collapsed-panel-status': !isDrawerExpanded()}">
  <app-status-panel [currentStepIndex]="currentStep()"></app-status-panel>
</div>
}